<template>
  <div>
    <d-row no-gutters>
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/logos/logo-s.png"
            />
            <!-- Title -->
            <h5
              class="auth-form__title text-center mb-4"
            >{{reset ? "Alterar Senha" : "Definir Senha"}}</h5>
            <!-- Loader -->
            <div v-if="loading">
              <loader :is-loading="loading"></loader>
            </div>
            <div v-else>
              <d-row md="12" class="mt-3">
                <d-col md="12">
                  <!-- Form Fields -->
                  <d-form>
                    <ValidationObserver ref="validationForm">
                      <d-form-row>
                        <d-col md="12" class="form-group">
                          <ValidationProvider rules="required" name="passwordFieldOne" v-slot="{errors, invalid}">
                            <b-input
                              :class="validatedForm | showValidateError(invalid)"
                              v-model="resetPassword.Password"
                              type="password"
                              placeholder="Senha"
                            />
                            <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </d-col>
                      </d-form-row>
                      <d-form-row>
                        <d-col md="12" class="form-group">
                          <ValidationProvider rules="required|confirmed:passwordFieldOne" v-slot="{errors, invalid}">
                            <b-input
                              :class="validatedForm | showValidateError(invalid)"
                              v-model="resetPassword.ConfirmPassword"
                              type="password"
                              placeholder="Repetir Senha"
                            />
                            <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </d-col>
                      </d-form-row>
                    </ValidationObserver>
                  </d-form>
                </d-col>
                <d-col md="12">
                  <div class="d-flex flex-column">
                    <span class="mb-2 mt-3 text-center">Requisitos complexidade da senha:</span>
                    <span class="req-item" :class="[pwdValidation.minChars ? 'pw-valid' : 'pw-invalid']">
                      <i v-if="pwdValidation.minChars" v-html="validIco"/>
                      <i v-else v-html="invalidIco"/>
                      A senha deve conter no mínimo 8 caracteres.
                    </span>
                    <span class="req-item" :class="[pwdValidation.minNumber ? 'pw-valid' : 'pw-invalid']">
                      <i v-if="pwdValidation.minNumber" v-html="validIco"/>
                      <i v-else v-html="invalidIco"/>
                      A senha deve conter ao menos um número.
                    </span>
                    <span class="req-item" :class="[pwdValidation.minUpperCase ? 'pw-valid' : 'pw-invalid']">
                      <i v-if="pwdValidation.minUpperCase" v-html="validIco"/>
                      <i v-else v-html="invalidIco"/>
                      A senha deve conter ao menos uma letra maiúscula.
                    </span>
                    <span class="req-item" :class="[pwdValidation.minLowerCase ? 'pw-valid' : 'pw-invalid']">
                      <i v-if="pwdValidation.minLowerCase" v-html="validIco"/>
                      <i v-else v-html="invalidIco"/>
                      A senha deve conter ao menos uma letra minúscula.
                    </span>
                    <span class="req-item" :class="[pwdValidation.minSpecialChar ? 'pw-valid' : 'pw-invalid']">
                      <i v-if="pwdValidation.minSpecialChar" v-html="validIco"/>
                      <i v-else v-html="invalidIco"/>
                      A senha deve conter ao menos um caracter especial.
                    </span>
                  </div>
                </d-col>
              </d-row>
              <d-row md="12" class="mt-4">
                <d-col md="12">
                  <button
                    v-on:click.stop="CreatePasswordValidation($event)"
                    class="btn btn-pill btn-accent d-table mx-auto"
                  >{{reset ? "ALTERAR" : "DEFINIR"}}</button>
                </d-col>
              </d-row>
            </div>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>

<script>
export default {
  name: "reset-password",
  data: function() {
    return {
      loading: false,
      reset: false,
      validatedForm: false,
      pwdValidation: {
        minChars: false,
        minLowerCase: false,
        minNumber: false,
        minSpecialChar: false,
        minUpperCase: false
      },
      resetPassword: {
        Token: null,
        Password: null,
        ConfirmPassword: null
      },
      validIco: "<i class='fas fa-check mr-2' style='color: #00FF00; width: 10px'>",
      invalidIco: "<i class='fas fa-times mr-2' style='color: #FF0000; width: 10px'>"
    };
  },
  computed: {},
  mounted() {
    this.reset = this.$route.query.reset === "True";
  },
  methods: {
    CreatePasswordValidation: function(e) {
      e.preventDefault();
      this.validatedForm = true;
      this.$refs.validationForm.validate().then(valid => {
        if (valid) {
          this.CreatePassword();
        }
      });
    },
    CreatePassword: function() {
      this.loading = true;
      var token = this.$route.query.token;
      if (
        (token == undefined || token.length < 1) &&
        (this.reset == false || this.reset == undefined)
      ) {
        this.$makeToast(
          "Não foi possível alterar sua senha.",
          "danger",
          "Senha inválida"
        );
        this.loading = false;
        return false;
      } else {
        const pwdIsValid = this.ValidatePasswordStrength(this.resetPassword.Password);
        if (pwdIsValid == false) {
          this.$makeToast(
            "A senha informada não atende aos requisitos de complexidade listados.",
            "danger",
            "Erro"
          );
          this.loading = false;
          return;
        }
      }
      this.resetPassword.Token = token;
      this.$store
        .dispatch("CreatePassword", this.resetPassword)
        .then(response => {
          this.$makeToast(`${response}`, "success", "Definição de senha");
          this.$router.push({ name: "login" });
        })
        .catch(error => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao definir a senha",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ValidatePasswordStrength: function(pwd) {
      const regexDigits = /\d+/gm;
      const regexLower = /[a-z]+/gm;
      const regexUpper = /[A-Z]+/gm;
      const regexSpecial = /\W+/gm;

      const leng = pwd != null ? pwd.length : 0;
      this.pwdValidation.minChars = leng >= 8 ? true : false;
      this.pwdValidation.minNumber = regexDigits.test(pwd);
      this.pwdValidation.minUpperCase = regexUpper.test(pwd);
      this.pwdValidation.minLowerCase = regexLower.test(pwd);
      this.pwdValidation.minSpecialChar = regexSpecial.test(pwd);

      let allValid = true;
      for (let rule in this.pwdValidation) {
        if (this.pwdValidation[rule] == false) {
          allValid = false;
          break;
        }
      }
      return allValid;
    }
  },
  watch: {
    "resetPassword.Password": function(nv) {
      this.ValidatePasswordStrength(nv);
    }
  }
};
</script>

<style scoped>
.req-item {
  font-size: 0.70rem;
}
.pw-valid {
  text-decoration: line-through;
  opacity: 0.5;
}
.pw-invalid {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/resetPassword.vue